import { P2 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Background = styled.div`
  padding: ${({ image }) => (image ? '37px' : '0px')} 15px;

  ${QUERIES.tabletAndUp} {
    padding: ${({ image }) => (image ? '56px 15px 60px' : '0px 15px')};
  }

  border-radius: ${themeStyle.radiusLarge};
  background-image: url(${({ image }) => image});
  background-size: cover;
  background-position: center center;
`;

export const H1XL = styled.h1`
  font-size: 62px;
  line-height: 64px;
  font-weight: 800;
  color: ${themeStyle.varInkMain};

  @media only screen and (max-width: 600px) {
    font-size: 42px;
  }
  @media only screen and (max-width: 600px) {
    line-height: 46px;
  }
`;
export const H2XL = styled.h2`
  font-weight: 800;
  font-size: 36px;
  line-height: 40px;
  font-weight: 800;
  color: ${themeStyle.varInkMain};

  @media only screen and (max-width: 600px) {
    font-size: 28px;
  }
  @media only screen and (max-width: 600px) {
    line-height: 36px;
  }
`;

export const Content = styled.div`
  width: ${({ innerContentWidth }) => innerContentWidth};
  max-width: 100%;
  margin: 0 auto;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ gap }) => gap};
`;

// P1 on desktop, P2 on mobile
export const Text = styled(P2)`
  text-align: center;

  ${QUERIES.tabletAndUp} {
    font-size: ${themeStyle.fontSize16};
    line-height: 26px;
  }

  p {
    margin: 0px;
  }
`;
